<template>

	<div class="box size30">
		<h2>Generate Showpad experience</h2>

		<div class="msgBox alert">
			Due to the current changes a new upload of the experience is requered!
		</div>

		<ul class="form">
			<li>
				<label>Language </label>
				<div class="selector">
					<select v-model="chosenLang">
						<option value="all">All</option>
						<option v-for="lang in languages" :value="lang.id" :key="lang.id">{{lang.language}}</option>
					</select>
				</div>
			</li>
			<li>
				<label>Select content</label>
				<div class="selector">
					<select v-model="chosenData">
						<option value="3">For deployment (approved data)</option>
						<option value="3,2">For staging (approved & testing data)</option>
					</select>
				</div>
			</li>
		</ul>

		<br>
		<p>This action can take a few minutes.</p>
		<div class="btn-container">
			<button class="btn" @click="buildClickHandler" :disabled="buildReady">Build experience</button>
			<button class="btn" @click="downloadClickHandler" :disabled="!downloadReady">Download experience</button>
		</div>
	</div>

</template>

<script>

import xhrModule from '../../modules/xhrModule.js'

export default {
	name: 'experiencebuilder',
	data () {
		return {
			languages: null,
			chosenLang: 'all',
			chosenData: '3',
			languagesLoaded: false,
			downloadReady: false,
			buildReady: true
		}
	},

	created () {
		this.body = document.querySelector('body')
		this.fetchLanguages()
		this.fetchSiteMap()
	},

	methods: {
		fetchLanguages () {
			var url = '/cms/api/markets'
			xhrModule.get(url, this.getMarketsCompleteHandler.bind(this))
		},

		getMarketsCompleteHandler (data) {
			this.languagesLoaded = true
			var markets = data.data

			// remove the main cms language from the list
			for (var lang in markets) {
				if (markets[lang].id === 1) {
					delete markets[lang]
				}
			}

			this.languages = markets
		},

		fetchSiteMap () {
			var url = '/cms/api/sitemap'
			xhrModule.get(url, this.sitemapFetchCompleted.bind(this))
		},

		sitemapFetchCompleted (data) {
			data = data.data

			// check if there is a file that has not been cached
			var cacheComplete = true

			var dataLength = Object.keys(data).length
			var dataInt = 0
			loop1:
			for (var key in data) {
				dataInt++
				var languages = data[key]
				var languagesLength = Object.keys(languages).length
				var langInt = 0
				loop2:
				for (var lang in languages) {
					langInt++
					var instances = languages[lang]
					loop3:
					for (var i = instances.length - 1; i >= 0; i--) {
						if (!instances[i].cache && instances[i].cacheable !== 'false') {
							cacheComplete = false
							this.evaluateBuild(cacheComplete)
							break loop1
						}

						if (dataInt === dataLength && langInt === languagesLength && i === 0) {
							this.evaluateBuild(cacheComplete)
						}
					}
				}
			}
		},

		evaluateBuild (cacheComplete) {
			if (cacheComplete) {
				this.downloadReady = true
				this.buildReady = true
			} else {
				this.downloadReady = false
				this.buildReady = false
			}
		},

		buildClickHandler (e) {
			// cache files genereren voor alle URL's van de site
			// dit kan je niet in 1 request doen... (gateway timeout)
			this.createCaches()
		},

		createCaches () {
			this.body.classList.add('loading')
			var url = '/cms/api/cache/createAllPages'
			xhrModule.get(url, this.createAllCacheCompleted.bind(this), this.createAllCacheFailed.bind(this))
		},

		createAllCacheCompleted (data) {
			this.body.classList.remove('loading')
			this.fetchSiteMap()
		},

		createAllCacheFailed (data) {
			this.body.classList.remove('loading')

			// keep creating caches in case we are getting a timeout
			if (data === 'timeout') this.createCaches()
		},

		downloadClickHandler (e) {
			e.preventDefault()

			if (!this.languagesLoaded) return

			// add loader
			this.$el.parentNode.classList.add('loading')

			var url = '/cms/api/experience/generate?'
			const marketsString = 'markets[]='
			const dataString = 'states[]='

			let finalMarketsString = ''
			let finalDataString = ''

			// add market(s)
			if (this.chosenLang === 'all') {
				for (var lang in this.languages) {
					finalMarketsString = finalMarketsString + marketsString + this.languages[lang].id + '&'
				}
			} else {
				finalMarketsString = marketsString + this.chosenLang + '&'
			}

			// add state(s)
			if (this.chosenData === '3') {
				finalDataString = dataString + this.chosenData
			} else {
				var arr = this.chosenData.split(',')
				for (var i = arr.length - 1; i >= 0; i--) {
					finalDataString = finalDataString + dataString + arr[i]
					if (i !== 0) finalDataString = finalDataString + '&'
				}
			}

			url = url + finalMarketsString + finalDataString
			xhrModule.download(url, this.generateBuildCompleteHandler.bind(this))
		},

		generateBuildCompleteHandler (data) {
			var blob = data.blob
			var filename = data.filename.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1]

			var file = window.URL.createObjectURL(blob)

			var a = document.createElement('a')
			a.href = file
			a.download = filename
			a.click()
			a.remove()

			this.$el.parentNode.classList.remove('loading')
		}
	}
}

</script>
